import { buttonVariants } from '@playcastdotio/Shadcn';
import { Link } from 'react-router-dom';
import { cn } from '../../utility/base';
import config from '../../config.json';

export const Community = () => {
  return (
    <div className='bg-content text-content-text m-0 h-auto w-full p-0'>
      <div className='container mx-auto h-auto w-full py-20'>
        <section id='community' className='flex flex-col gap-y-4 px-4 text-center'>
          <h2 className='text-3xl font-bold'>Join the Community</h2>
          <p className='lg:px-56'>
            Join the growing group of Playcasters on Discord to chat with other streamers, the team building the apps, and report bugs you
            find so we can fix them as soon as possible. And those of you interested in becoming a UX Tester can join that channel to be
            sent surveys, prototypes, and other previews of stuff we're working on.
          </p>
          <div className='flex w-full flex-col justify-center gap-2 md:flex-row'>
            <Link to={config.DISCORD_URL} className={cn(buttonVariants(), 'rounded-full bg-amber-400')}>
              Join our Discord
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};
